// Real pages from BILLEDKLAR™ Bind 1, WebP 1512x1890 in Impultienda Recursos (store BILLEDKLAR b597a5c7-...).
const BASE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/b597a5c7-f46f-4ca0-afb9-93c1b475a7ec/';
export const pageSamples: Array<{
  src: string;
  label: string;
  title: string;
  text: string;
}> = [{
  src: BASE + '1792721820501_billedklar-bind1-s01-forside-da2a7b98.webp',
  label: 'Bind 1 · Side 1',
  title: 'Årsplan + 12 lektioner minut for minut',
  text: 'Årsplaner for 1.–2., 3.–4. og 5.–6. klasse, bygget på Fælles Mål – samlet i ét bind.'
}, {
  src: BASE + '1792721824510_billedklar-bind1-s13-lektion1-8219f3c6.webp',
  label: 'Bind 1 · Side 13',
  title: 'Lektion 1 · Lærerside',
  text: 'Primærfarver og farveblanding (1. klasse): mål, materialer, minut for minut og lærerens instruktion.'
}, {
  src: BASE + '1792721827936_billedklar-bind1-s14-elevark-d5bb9831.webp',
  label: 'Bind 1 · Side 14',
  title: 'Elevark i 3 niveauer',
  text: 'Samme mål i 3 niveauer – støtte, basis og udfordring – så alle elever kan være med.'
}, {
  src: BASE + '1792721831962_billedklar-bind1-s05-aarsplan-046cf390.webp',
  label: 'Bind 1 · Side 5',
  title: 'Årsplan 1.–2. klasse',
  text: 'Hele skoleåret uge for uge – med emner, teknikker og kompetenceområder.'
}, {
  src: BASE + '1792721835794_billedklar-bind1-s39-evaluering-6d0343ce.webp',
  label: 'Bind 1 · Side 39',
  title: 'Evalueringsskema',
  text: 'Et enkelt skema til at følge elevernes udvikling i billedfremstilling, billedanalyse og billedkommunikation.'
}];
